import styled, { css } from 'styled-components'

import { InputStyled } from 'components/forms/input'
import { InputStyled as InputMaskStyled } from 'components/forms/inputMask'
import { ButtonStyle } from 'components/button'

import { MEDIA } from 'utils/constants'

import { assetPrefix } from 'config/env_config'

const { MOBILE_UP, MOBILE } = MEDIA

export const CardContent = styled.div`
  width: 100%;

  @media screen and ${MOBILE_UP} {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    position: relative;
  }
`

export const LabelAddress = styled.div`
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 145%;
  display: flex;
  align-items: center;
  gap: 8px;

  color: var(--gray-5);
  margin-bottom: 1.2rem;

  @media screen and ${MOBILE} {
    margin-top: 3px;
    font-size: 13px;

    img {
      width: 18px;
    }
  }
`

export const LabelPhone = styled(LabelAddress)`
`

export const PartnerBody = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const LabelColor = styled.div`
  color: var(--schedule-gray);
  font-size: 12px;
  margin-top: -4px;
  font-weight: 700;
  font-family: var(--font-family);

  @media screen and ${MOBILE} {
    position: absolute;
    top: 0;
    right: 0;
    align-self: baseline;
    margin-top: 0px;
  }
`

export const PaymentBadge = styled.div`
  width: 120px;
  background-color: var(--cobasi-blue-light-6);
  color: var(--cobasi-primary);
  font-size: 12px;
  line-height: 15px;
  font-family: var(--primary-font);
  font-weight: 400;
  padding: 3px 0px;
  border-radius: 8px;
  text-align: center;
  display: block;
`

export const RadioGroupLocation = styled.div`
  max-width: ${props => props.fullWidth ? '100%' : '60rem'};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: ${props => props.justifyContent || 'space-between'};
  flex-wrap: wrap;
  ${props => props.gap && `gap: ${props.gap}`};

  label {
    font-family: var(--primary-font);
    font-weight: 400;
    font-size: 1.2rem;
  }
`

export const CustomAddressInputs = styled.div`
  position: relative;
  display:flex;
  align-items:center;
  flex-wrap:nowrap;
  gap:15px;

  ${ButtonStyle} {
    padding: 1.6rem 5.25rem;
    font-size: 2rem;
    font-weight: 600;
    height: 48px;
    width: 172px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  ${InputStyled},
  ${InputMaskStyled} {
    padding: 1.6rem 48px 1.6rem 1.6rem;
    font-weight: normal;
    font-size: 1.6rem;
    height: 48px !important;
  }

  @media screen and ${MOBILE_UP} {
      >:nth-last-child(2){
          flex:1;
      }
  }

  @media screen and ${MOBILE} {
      flex-direction:column;
      gap: 32px;

      > * {
          width:100%;
      }

      ${InputStyled}, ${InputMaskStyled} {
        height: 56px;
      }

      ${ButtonStyle} {
        width: 100%;
        border-radius: 8px;
        height: 48px;
        padding: 8px 16px;
      }
  }
`

export const CustomAddressComplete = styled.div`
  display:flex;
  align-items:center;
  flex-wrap:nowrap;
  gap:15px;
  flex:1;

  @media screen and ${MOBILE} {
    flex-direction:column;
  }
`

export const LinkSeeMore = styled.a`
    font-family: var(--primary-font);
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 145%;
    text-decoration: none;
    color: var(--cobasi-primary);

  @media screen and ${MOBILE} {
    font-size: 14px;
  }
`

export const Count = styled.h3`
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 23.2px;
  width: 100%;

  text-align: center;
`

export const LoadMore = styled.button`
  border: none;
  background-color: transparent;
  cursor: pointer;
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: normal;
  color: var(--cobasi-blue-light-8);
  padding: 13px 16px;
`

export const WrapperButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 24px 0px;
`
export const Warning = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px;
  gap: 16px;
  border-radius: 24px;
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 145%;
  color: var(--gray-5);
  background-color: var(--pet-anjo-light-blue);
  margin-bottom: 24px;
`

export const Wrapper = styled.div`
  margin-top: 32px;
`

export const AlignWrappers = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;

  @media screen and (max-width: 1200px) {
    padding: 0 16px;
  }
`

export const WrapperText = styled.div`
  font-family: var(--primary-font);
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
`

export const WrapperTitle = styled(WrapperText)`
  width: 100%;
  max-width: 1040px;
  margin-bottom: 24px;
  padding-top: 16px;
  font-size: 16px;
  color: var(--gray-2);
`

export const LabelCompany = styled(WrapperText)`
  display: flex;
  align-items: center;
  span {
    font-size: 14px;
    line-height: 19.2px;
    color: var(--gray-2);
  }
`

export const DistanceChip = styled.label`
  font-family: var(--primary-font);
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  color: var(--gray-9);
  padding: 2px 8px;
  border: 1px solid var(--gray-9);
  border-radius: 8px;
  height: fit-content;
`

export const LabelInfo = styled(WrapperText)`
  font-weight: 400;
  font-size: 14px;
  line-height: 19.2px;

  display: flex;
  align-items: center;
  gap: 8px;

  & + & {
    margin-top: 8px;
  }

  label {
    color: var(--gray-5);
    font-size: 12px;
  }
`

export const PartnerServicePrice = styled.div`
  display: flex;
  width: 135px;
  height: 58px;
  padding: 8px;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 8px;
  border: 1px solid var(--silver);

  .service-name {
    font-size: 1.2rem;
    color: var(--gray-2);
  }
  
  .service-price {
    font-size: 1.4rem;
    color: var(--gray-5);
    font-weight: 600;
  }
`

export const WrapperInfoRadio = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`

export const WrapperPartnerAdressRadio = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  border-bottom: 1px solid var(--silver);
  padding-bottom: 12px;
`

export const WrapperImageAndInfo = styled.div`
  display: flex;
`

export const WrapperCompanyNameAndDistance = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 8px;

  svg {
    margin: 0px 1px;
  }
`

export const Card = styled.div`
  padding: 16px;
  cursor: pointer;
  box-sizing: border-box;
  border: 1px solid var(--silver);
  border-radius: 2.4rem;
  margin-bottom: 2.4rem;
  width: 100%;
  background: var(--the-white);

  ${({ checked }) => checked && css`
    border: 2px solid #00A7D7;
  `}
`

export const StoreList = styled.div`
  margin-top: 24px;
`

export const PartnerImage = styled.div`
  min-height: 72.75px;
  max-width: 76px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    border-radius: 50%;
    width: 96px;
    height: 96px;
    object-fit: scale-down;
    background-color: var(--gray-blue);
  }

  img.partner-no-logo {
    background: url("${assetPrefix}/static/images/partner-no-logo.png");
    background-repeat:no-repeat;
    background-size:100%;
    width: 28px;
    height: 28px;
    opacity: 0.5;
  }

  @media screen and (max-width: 576px) {
    max-width: 100%;

    img {
      width: 64px;
      height: 64px;
    }
  }
`

export const Container = styled.div`
  border-radius: 2.4rem;
  margin-bottom: 36px;

  /* ${props => props.hasAnotherPetScheduling && css`
    @media screen and (min-width: 860px) {
      margin: 50px 0;
    }

    @media screen and (max-width: 860px) {
      margin: 0 0 36px;
    }
  `} */
`

export const WrapperContainerAndTitle = styled.div`
  width: 558px;

  @media screen and (max-width: 860px) {
    padding: 0;
    width: 100%;
  }
`

export const CardBody = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;

  .mobile {
    display: none;
  }

  @media screen and (max-width: 576px) {
    .mobile {
      display: flex;
    }

    .desktop {
      display: none;
    }
  }

  @media screen and ${MOBILE} {
    justify-content: flex-start;
  }
`
